"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Tabs_exports = {};
__export(Tabs_exports, {
  Tabs: () => Tabs
});
module.exports = __toCommonJS(Tabs_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_react_native = require("react-native");
var import_common = require("./common");
var import_Tabs = require("./Tabs.shared");
__reExport(Tabs_exports, require("./TabContext"), module.exports);
__reExport(Tabs_exports, require("./TabList"), module.exports);
__reExport(Tabs_exports, require("./TabSlot"), module.exports);
__reExport(Tabs_exports, require("./TabTrigger"), module.exports);
__reExport(Tabs_exports, require("./Tabs.shared"), module.exports);
function _type_of(obj) {
  "@swc/helpers - typeof";
  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function Tabs(props) {
  var { children, asChild, options, ...rest } = props;
  var Comp = asChild ? import_common.ViewSlot : import_react_native.View;
  var { NavigationContent } = (0, import_Tabs.useTabsWithChildren)({
    children: asChild && /* @__PURE__ */ (0, import_react.isValidElement)(children) && children.props && _type_of(children.props) === "object" && "children" in children.props ? children.props.children : children,
    ...options
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Comp, {
    style: styles.tabsRoot,
    ...rest,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NavigationContent, {
      children
    })
  });
}
var styles = import_react_native.StyleSheet.create({
  tabsRoot: {
    flex: 1
  }
});
//# sourceMappingURL=Tabs.js.map
